// Б.1.d: регистратор хуков Синтетика. Импортируется один раз из engine/match.js,
// чтобы выполнить registerUnitSummonedExtraHandler при загрузке модуля.

import { registerUnitSummonedExtraHandler } from '../deus/hooks.js';
import { rastOnAnyUnitSummoned }       from './rast-passive.js';
import { spisannyyDronOnSummon }       from './spisannyy-dron.js';
import { attachMod }                   from './modifications.js';
// C.1: stubs/реализации новых v6-юнитов Синтетика.
import './c1/units-batch.js';
// C.1: моды-расширение (MOD_REGISTRY, триггерные моды, passive_modifier юнитов).
import './c1/mods-batch.js';
// Этап 25: Действия Синтетика на v6 ID (через registerC1Order).
import './c1/actions-c1.js';

// Этап 25: регистрация Героев Синтетика (реализации в *-active.js / *-passive.js).
import { registerImplementedAbility } from '../warn-unimplemented.js';
for (const id of ['syn_bishor', 'syn_rast', 'syn_skvill', 'syn_uein']) {
  registerImplementedAbility(id, 'active', 'trigger');
}

// Этап 25: регистрация Mod-карт (Mod-эффекты — это не способности самой карты-Мода,
// а handlers при attach. Здесь регистрируем чтобы аудит был чистый.)
for (const id of [
  'syn_mod_batareya', 'syn_mod_boevoy_stim', 'syn_mod_implant_berserka',
  'syn_mod_implant_mertvetsa', 'syn_mod_iskin', 'syn_mod_kamuflyazh',
  'syn_mod_krovavy_implant', 'syn_mod_krovyanoy_nasos', 'syn_mod_mehanodendrit',
  'syn_mod_ostry_vzglyad', 'syn_mod_peregruz', 'syn_mod_stek_usilitel',
  'syn_mod_vtoroe_serdtse', 'syn_mod_zashchitnaya_obolochka', 'syn_mod_zaveshanie',
  'syn_mod_zavodskoy'
]) {
  registerImplementedAbility(id, 'trigger', 'deathrattle');
}

// Этап 25: regular юниты с триггерами, реализованные в legacy файлах.
registerImplementedAbility('syn_fixer', 'trigger', 'active');
registerImplementedAbility('syn_spisany_dron', 'trigger');
registerImplementedAbility('syn_torchok', 'trigger');

// onUnitSummoned-extra: каждый призванный юнит сначала получает override
// overloadThreshold (Списанный дрон), затем — Мод от Раста (если он на поле).
registerUnitSummonedExtraHandler((state, _ownerIdx, card) => {
  spisannyyDronOnSummon(card);
  rastOnAnyUnitSummoned(state, card, attachMod);
});

// Реэкспорт для тестов и внешнего кода.
export { applySkvillStartingMods, HERO_ID as SKVILL_ID } from './skvill-passive.js';
export { bishorOnAllyModified,    HERO_ID as BISHOR_ID } from './bishor-trigger.js';
export { riperOnTurnStart,        HERO_ID as RIPER_ID  } from './riper-trigger.js';
export { rastOnAnyUnitSummoned,   HERO_ID as RAST_ID   } from './rast-passive.js';
// Б.3: активки 4 Героев Синтетика.
export { bishorActive, bishorActiveAvailable, getBishorActiveTargets } from './bishor-active.js';
export { riperActive,  riperActiveAvailable,  getRiperActiveTargets  } from './riper-active.js';
export { rastActive,   rastActiveAvailable,   getRastActiveTargets   } from './rast-active.js';
export { skvillActive, skvillActiveAvailable, getSkvillActiveTargets } from './skvill-active.js';
export { dilerOrder,              CARD_ID as DILER_ID  } from './diler.js';
export { kiberPsihOnModAttached, kiberPsihOnModDetached, CARD_ID as KIBERPSIH_ID } from './kiber-psih.js';
export { spisannyyDronOnSummon,   CARD_ID as DRON_ID   } from './spisannyy-dron.js';
// Б.2.a: 5 Модов с эффектами.
export { batareyaOnDeath,         MOD_ID as BATAREYA_MOD_ID    } from './eksperimentalnaya-batareya.js';
export { vtoroeSerdtseOnDeath, applyPendingResurrects, MOD_ID as SERDTSE_MOD_ID } from './vtoroe-serdtse.js';
export { tsifrovoeZaveschanieEot, MOD_ID as ZAVESCHANIE_MOD_ID } from './tsifrovoe-zaveschanie.js';
export { vychMoschnostiEot,       MOD_ID as MOSCHNOSTI_MOD_ID  } from './vychislitelnye-moschnosti.js';
export { MOD_ID as PEREGRUZ_MOD_ID } from './peregruz-retseptorov.js';
export { applyModDeathTriggers, applyModEndOfTurnTriggers } from './modifications.js';
// Б.2.b: 4 Действия Синтетика — диспетчер и резолверы.
export {
  actionNeedsTarget as synActionNeedsTarget,
  getActionTargets as synGetActionTargets,
  resolveAction as synResolveAction,
  STIMULATOR_ID, UDAR_ID, PROSHIVKA_ID, PROPAGANDA_ID
} from './actions.js';
export { tickKustarnyyDoT } from './kustarnyy-stimulyator.js';
// Б.2.d: 6 сложных юнитов.
export { fikserOnTurnStart, fikserOrder, CARD_ID as FIKSER_ID } from './fikser.js';
export { tehnoPalachOrder, CARD_ID as PALACH_ID } from './tehno-palach.js';
export { zakalennyyOnAnyUnitDamaged, CARD_ID as ZAKAL_ID } from './zakalennyy-kiber-psih.js';
export { iiModelEot, CARD_ID as IIMODEL_ID } from './ii-model.js';
export { lichnyyOnSpawn, CARD_ID as LICHNYY_ID } from './lichnyy-telohranitel.js';
export {
  initsiatorOnSpawn, initsiatorOnEndOfTurn, isInitiatorActive,
  CARD_ID as INITSIATOR_ID
} from './initsiator.js';
